/**
 * @deprecated Prefer var(--border-radius-xxs), var(--border-radius-xs), etc. instead of BorderRadius enum
 */
export enum BorderRadius {
  Xxs = '0.125rem',
  Xs = '0.25rem',
  S = '0.5rem',
  M = '1rem',
  Full = '9999px',
}

/**
 * @deprecated Prefer var(--border-width-avatar) and var(--border-width-table) instead of BorderWidth enum
 */
export enum BorderWidth {
  Avatar = '2px',
  Table = '1px',
}
